var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeEvery } from "redux-saga/effects";
import logger from "../../logger";
import { showAlert } from "../../utils/alert/alert.utils";
import * as documentApi from "../documents/document.api";
import { performExternalActionStart, performExternalActionSucceeded, performExternalActionFailed, } from "./externalAction.actions";
import * as externalActionApi from "./externalAction.api";
function performExternalActionStartFlow(action) {
    var _a, id, key, type, data, token, onSuccess, onFailure, finalData, presignedUrl, presignedUrl, unknownError_1, error;
    var _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = action.payload, id = _a.id, key = _a.key, type = _a.type, data = _a.data, token = _a.token, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _f.label = 1;
            case 1:
                _f.trys.push([1, 8, , 10]);
                finalData = data ? __assign({}, data) : data;
                if (!((finalData === null || finalData === void 0 ? void 0 : finalData.IDCardFront) && !finalData.IDCardFront.url)) return [3 /*break*/, 3];
                return [4 /*yield*/, call(documentApi.uploadDocumentToS3, finalData.IDCardFront)];
            case 2:
                presignedUrl = _f.sent();
                finalData = __assign(__assign({}, finalData), { IDCardFront: presignedUrl });
                _f.label = 3;
            case 3:
                if (!((finalData === null || finalData === void 0 ? void 0 : finalData.IDCardBack) && !finalData.IDCardBack.url)) return [3 /*break*/, 5];
                return [4 /*yield*/, call(documentApi.uploadDocumentToS3, finalData.IDCardBack)];
            case 4:
                presignedUrl = _f.sent();
                finalData = __assign(__assign({}, finalData), { IDCardBack: presignedUrl });
                _f.label = 5;
            case 5: return [4 /*yield*/, call(externalActionApi.performExternalAction, {
                    id: id,
                    key: key,
                    data: finalData,
                    token: token,
                })];
            case 6:
                _f.sent();
                return [4 /*yield*/, put(performExternalActionSucceeded.getAction({
                        type: type,
                    }))];
            case 7:
                _f.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 10];
            case 8:
                unknownError_1 = _f.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(performExternalActionFailed.getAction({
                        type: type,
                        error: error,
                    }))];
            case 9:
                _f.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                showAlert({
                    type: "error",
                    message: ((_e = (_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.rawException) === null || _d === void 0 ? void 0 : _d.response) === null || _e === void 0 ? void 0 : _e.error) ||
                        "Something went wrong",
                });
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(performExternalActionStart.type, performExternalActionStartFlow)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
